import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signup } from '../services/api';

function Signup() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }
    try {
      const { data } = await signup({
        name: formData.name,
        email: formData.email,
        password: formData.password
      });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/business-profile');
    } catch (error) {
      alert(error.response?.data?.error || 'Signup failed');
    }
  };

  return (
    <div className="container" style={{ 
      maxWidth: '400px', 
      marginTop: '80px',
      padding: '20px'
    }}>
      <div className="card" style={{
        padding: window.innerWidth <= 480 ? '20px' : '28px'
      }}>
        <h2 style={{ 
          marginBottom: '24px', 
          textAlign: 'center',
          fontSize: window.innerWidth <= 480 ? '22px' : '28px'
        }}>Signup</h2>
        <form onSubmit={handleSignup}>
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <label>Password</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <label>Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            Signup
          </button>
        </form>
        <p style={{ 
          textAlign: 'center', 
          marginTop: '16px',
          fontSize: window.innerWidth <= 480 ? '13px' : '15px'
        }}>
          Pehle se account hai? <Link to="/login">Login karein</Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;
